export default __webpack_public_path__ + "static/media/stand.7b943671.svg";